import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettingsGear = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16,
			fill: "black",
			fillOpacity: .38
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.9999 17.5807C15.1865 17.5807 14.5248 16.9189 14.5248 16.1056C14.5248 15.2922 15.1865 14.6305 15.9999 14.6305C16.8132 14.6305 17.4749 15.2922 17.4749 16.1056C17.4749 16.9189 16.8132 17.5807 15.9999 17.5807ZM15.9999 13.2461C14.423 13.2461 13.1404 14.5287 13.1404 16.1056C13.1404 17.6824 14.423 18.9651 15.9999 18.9651C17.5767 18.9651 18.8593 17.6824 18.8593 16.1056C18.8593 14.5287 17.5767 13.2461 15.9999 13.2461Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.3888 17.7687C21.1147 18.4997 20.6924 19.214 20.1671 19.8349L19.8521 20.2066L20.8862 21.9932L18.7273 23.2551L17.6869 21.4574L17.192 21.5675C16.7545 21.6644 16.398 21.7053 16 21.7053C15.5833 21.7053 15.1777 21.6596 14.826 21.5717L14.3207 21.445L13.272 23.2551L11.1138 21.9932L12.159 20.1873L11.8129 19.8128C11.2127 19.1628 10.8362 18.528 10.6271 17.8165L10.4811 17.3195H8.3844V14.8338H10.4423L10.6112 14.3845C10.8853 13.6536 11.3076 12.9392 11.8329 12.3183L12.1472 11.9459L11.1138 10.16L13.272 8.89815L14.3138 10.6965L14.8087 10.5864C15.2441 10.4888 15.5999 10.448 16 10.448C16.4174 10.448 16.823 10.4944 17.174 10.5823L17.68 10.7089L18.7273 8.89815L20.8862 10.16L19.841 11.966L20.1871 12.3405C20.7866 12.9904 21.1638 13.6252 21.3729 14.3368L21.5189 14.8338H23.6156V17.3195H21.5577L21.3888 17.7687ZM25 18.703V13.4485H22.5309C22.3018 12.8664 21.9792 12.3251 21.5425 11.7893L22.7753 9.66013L18.2261 7L16.9905 9.13544C16.3572 9.03992 15.683 9.03507 15.0115 9.13821L13.7739 7L9.22473 9.66013L10.4686 11.8087C10.0831 12.321 9.75496 12.8768 9.49885 13.4485H7V18.703H9.46908C9.6982 19.2852 10.0215 19.8272 10.4575 20.3623L9.22473 22.4922L13.7739 25.1516L15.0102 23.0168C15.6435 23.1124 16.3156 23.1179 16.9885 23.0134L18.2261 25.1516L22.7753 22.4922L21.5314 20.3429C21.9162 19.8306 22.2443 19.2755 22.5005 18.703H25Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgSettingsGear);
export { ForwardRef as ReactComponent };
